(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1898],{

/***/ 31898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hero033": function() { return /* binding */ Hero033; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_RichTextWidget__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14258);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87900);
/* harmony import */ var _Hero033_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32385);
/* harmony import */ var _Hero033_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Hero033_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var Hero033 = function(param) {
    var payload = param.payload;
    var ref;
    var headline = (ref = payload === null || payload === void 0 ? void 0 : payload.headline) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var subtitle = (ref1 = payload === null || payload === void 0 ? void 0 : payload.subtitle) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var description = (ref2 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    var image = (ref3 = payload === null || payload === void 0 ? void 0 : payload.image) !== null && ref3 !== void 0 ? ref3 : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Hero033_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Heading2 */ .XJ, {
                    className: (_Hero033_module_scss__WEBPACK_IMPORTED_MODULE_3___default().headline),
                    color: "dark",
                    children: headline
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Hero033_module_scss__WEBPACK_IMPORTED_MODULE_3___default().content),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Heading6 */ .Cd, {
                            className: (_Hero033_module_scss__WEBPACK_IMPORTED_MODULE_3___default().subtitle),
                            color: "dark",
                            children: subtitle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RichTextWidget__WEBPACK_IMPORTED_MODULE_1__/* .RichText */ .H, {
                            value: description,
                            className: (_Hero033_module_scss__WEBPACK_IMPORTED_MODULE_3___default().description),
                            color: "dark"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .ImageLite */ .NH, {
                    image: image,
                    className: (_Hero033_module_scss__WEBPACK_IMPORTED_MODULE_3___default().image)
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Hero033);


/***/ }),

/***/ 32385:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hero033_wrapper__imNzf","headline":"Hero033_headline__7dNKz","content":"Hero033_content___OVGp","subtitle":"Hero033_subtitle__vlmSL","description":"Hero033_description__WgiEL","image":"Hero033_image__FZwYL"};

/***/ })

}]);